module.exports = __webpack_public_path__ + "static/logo-smsm-c0e9bcae8d0c8f728ca3d7e0a3e4aaea.svg";